export const USER_KIND_USER = "User";
export const USER_KIND_DART_AI = "Dart AI";
export const USER_KIND_CUSTOM = "Custom";
